var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuTShirtJunior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: .75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.6365604,31.1668143c.4357643,11.5787086.4480095,22.75659.4480095,22.75659h-22.1564922s.0122433-11.1778814.4480057-22.75659"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.9015541,16.7580237c-1.1137104.5104505-2.9327786,1.0883961-4.6224796,1.6737376-2.4025492.8322844-4.2857468,2.7256983-5.1034375,5.1332535l-3.2264469,9.49974c-.1015804.2990867.0783596.6202756.3864701.6898408l5.718449,1.2406641,1.1434234.308609c.4710999-1.6089668,1.1703453-4.1198578,1.1703453-4.1198578"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.663702,31.1804499s.6676674,2.5070152,1.1387672,4.1159801h0l6.8618724-1.5492735c.3081098-.069565.4880498-.3907528.3864707-.6898392l-3.2222018-9.487344c-.8160437-2.4027321-2.6935717-4.2934248-5.089773-5.1284505-1.6824113-.5862849-3.49442-1.1672814-4.610574-1.6788519"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.7778797,
    y1: 16.0850672,
    x2: 39.775526,
    y2: 16.0874228
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.360899,16.8654665c-.5583267,1.1472225-3.2971344,3.6581383-6.3618965,3.6581383-3.0624027,0-5.7912121-2.5058727-6.3518677-3.6530943l.7704086-.3355064.8174191-.4499321c.0023575,0,.0047169,0,.0070744.0023441.0730114.0282812.3415642.4923468.8551178,1.034153.0047169.0070744.0094318.011776.0164776.0188503.004715.0070591.0117893.0164909.0188351.023551.0801144.0918751.285059.3133116.6101456.5700884.2567635.2002287.5912819.4240217.9964561.6148329.0565338.0282669.1130676.0541763.1719589.0800858.0706825.0306244.1413651.0588913.2143784.0871735.0023575,0,.0070419.0023441.0094032.0047016.1484375.0565338.308609.1083679.4734955.1531258.1672745.0471172.3415947.0848026.5253143.1130695.0895462.0164909.1813927.0282669.2779846.0376987.0942345.011776.1884689.0188351.2874184.0235519h.0023575c.0871315.004715.1766777.0070591.2685242.0070591h.0424156c1.1495781-.0023441,2.0588722-.3462811,2.765583-.793869.0424156-.02355.0848007-.0518169.1271858-.0800838.0070763-.0047169.0165062-.0094337.0235825-.0164928.5676994-.3722038.8998604-.7420492.9729004-.8268509.0046883-.0047159.0070457-.0094175.0094032-.011776.0023613-.0023575.0047188-.0047159.0047188-.0047159.4852867-.5182552.7538109-.9634705.8409996-1.0294371.0023575-.0023584.004715-.0023584.0070724-.0023584.004715-.0023575.0094032-.0023575.0117607-.0023575l1.5853729.7780504Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.739069,18.3488917c-.4051743-.1908112-.7396927-.4146042-.9964561-.6148329-.3250866-.2567768-.5300312-.4782133-.6101456-.5700884.1813927.188467.3910828.3839788.6313381.5724316.280344.2214355.605402.4334545.9752636.6124897Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.1336193,18.7870478c-.1837196-.0282669-.3580399-.0659523-.5253143-.1130695.1672745.0447598.3439522.0824432.5253143.1130695Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.2597771,
    y1: 16.0765957,
    x2: 39.7583408,
    y2: 16.0765957
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.391407,
    y1: 17.4301886,
    x2: 38.6015682,
    y2: 17.4301886
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTShirtJunior);
export default __webpack_public_path__ + "static/media/Menu_T-shirt_junior.f2e1f84077219e4e96ca28d0b0238dc2.svg";
export { ForwardRef as ReactComponent };